import styled from 'styled-components';

export const Container = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
`

export const ContainerBody = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
    flex-direction: column;
`

export const Row = styled.div`
    background-color: transparent;
    padding: 0px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
`

export const CustomerName = styled.span`
    margin-right: 10px;
    font-weight: bold;
`

export const Values = styled.div`
    display: flex;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    cursor: pointer;
    border: 1px solid #eee;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 5px;

    &:hover {
        background-color: #f5f5f5;
    }
`

export const ItalicText = styled.span`
    font-style: italic;
`

export const UnderlineText = styled.span`
    text-decoration: underline;
`

export const ConfirmationText = styled.div`
    text-align: justify;
`

export const FormFilters = styled.div`
    display: flex;
    flex-direction: column;
`
export const ListCustomers = styled.div`
    display: flex;
    flex-direction: column;
`

export const Title = styled.div`
    font-size: 0.85em;
    line-height: 1;
    margin-bottom: 3px;
`;

export const Subtitle = styled.div`
    font-size: 0.6em;
    line-height: 1;
    font-weight: normal;
`;

export const LeftButtons = styled.div`
    display: flex;
    justify-content: flex-start;
    flex: 1;
`

export const RightButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    flex: 1;
`

export const SpacedButtons = styled.div`
    display: flex;
    justify-content: space-between;
    flex: 1
`